import { getFramework, IFramework } from '@/framework';
import { IMarkupDrawConfig, MarkupType } from '@/version-types';
import { DRAW_EVENTS } from './event-name';
import { getMarkupLayerState } from './states/markup-state';

export class MarkupDrawPlugin {
    private framework: IFramework;

    constructor(id: string) {
        this.framework = getFramework(id);
    }

    /** 获取绘制配置 */
    getConfig() {
        return getMarkupLayerState(this.framework.identity).drawConfig;
    }

    /** 打开绘制 */
    open(config: IMarkupDrawConfig) {
        getMarkupLayerState(this.framework.identity).setDrawConfig(config);
    }

    /** 关闭绘制 */
    close() {
        getMarkupLayerState(this.framework.identity).setDrawConfig(null);
    }

    /** 监听绘制配置变化 */
    onConfigChange(fn: (drawConfig: IMarkupDrawConfig | null) => void) {
        return this.framework.events.on(DRAW_EVENTS.CONFIG_CHANGE, fn);
    }

    /** 监听绘制结束 */
    onDrawEnd(fn: (markupType: MarkupType) => void) {
        return this.framework.events.on(DRAW_EVENTS.DRAW_END, fn);
    }
}
